import { Module } from '../utils/_application'

const $ = jQuery

export default class LazyLoad extends Module {
  ready (app) {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('Trident')
    if (msie > 0) // If Internet Explorer, return true
    {
      this.ieResolve(document.querySelectorAll('[lazy-load]'))
      return true
    }

    this.ieResolve(document.querySelectorAll('[critical]'))
    window.onload = () => {
      this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))

      window.addEventListener('scroll', () => {
        this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))
      })

      window.addEventListener('click', () => {
        this.resolveLazyLoad(document.querySelectorAll('[lazy-load]'))
      })
    }
  }

  isScrolledIntoView (elem) {
    const docViewTop = window.scrollY
    const elemTop = elem.getBoundingClientRect().top + document.body.scrollTop - 1000

    return (elemTop <= docViewTop)
  }

  ieResolve (lazyElements) {
    Array.prototype.forEach.call(lazyElements, (item) => {
      item.setAttribute('lazy-loaded', 'true')
      const fullSize = item.getAttribute('full')
        ? item.getAttribute('full')
        : item.getAttribute('src')

      const preload = new Image()
      preload.onload = () => {
        item.setAttribute('src', fullSize)
        item.style.filter = 'blur(0px)'
        item.removeAttribute('lazy-load')
      }
      preload.src = fullSize
    })
  }

  resolveLazyLoad (lazyElements) {
    Array.prototype.forEach.call(lazyElements, (item) => {
      if (this.isScrolledIntoView(item) && !item.getAttribute('lazy-loaded') && item.offsetParent !== null ||
            item.getAttribute('afterload') && !item.getAttribute('lazy-loaded') && item.offsetParent !== null) {
        item.setAttribute('lazy-loaded', 'true')
        item.removeAttribute('lazy-load')

        const fullSize = item.getAttribute('full')
          ? item.getAttribute('full')
          : item.getAttribute('src')
        const srcsetfull = item.getAttribute('srcsetfull')

        const cssbg = item.getAttribute('cssbg')

        if (cssbg) {
          item.style.backgroundImage = 'url(' + cssbg + ')'
        } else if (fullSize) {
          if (srcsetfull) {
            item.setAttribute('srcset', srcsetfull)
          }
          item.setAttribute('src', fullSize)
        }
      }
    })
  }
}
